export const setLoggedInUser = (data) => {
  return {
    type: 'SET_LOGGED_IN_USER',
    payload: data
  };
};

export const setUserOrganization = (data) => {
  return {
    type: 'SET_USER_ORGANIZATION',
    payload: data
  };
};

export const logIn = () => {
  return {
    type: 'LOG_IN'
  };
};

export const logOut = () => {
  return {
    type: 'LOG_OUT'
  };
};

export const setUserRepack = (data) => {
  return {
    type: 'SET_USER_REPACK',
    payload: data
  };
};
